/** FilterChip — .t-chipf: pad 5/12, radius full; active = ink bg + white. */
import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { colors, fontFamily, fontSize, fontWeight, radii } from '../theme';

type Props = { label: string; active: boolean; onPress: () => void };

export default function FilterChip({ label, active, onPress }: Props) {
  return (
    <Pressable
      onPress={onPress}
      style={[styles.chip, active ? styles.active : null]}
    >
      <Text style={[styles.text, active ? styles.activeText : null]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  chip: {
    paddingVertical: 5,
    paddingHorizontal: 12,
    borderRadius: radii.full,
    borderWidth: 1,
    borderColor: colors.line,
    backgroundColor: colors.card,
    cursor: 'pointer',
  } as any,
  active: { backgroundColor: colors.ink, borderColor: colors.ink } as any,
  text: { fontFamily: fontFamily.sans, fontSize: fontSize.sm, fontWeight: fontWeight.medium, color: colors.ink3 },
  // paper (not #fff): the active chip's bg is `ink`, which inverts in dark mode
  // — a hardcoded white label went invisible there.
  activeText: { color: colors.paper as any },
});
